import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Popover from 'components/UI/Popover';
import VariantIssueOption from 'common/VariantIssueOption';
import Icon from 'view/Icon';
import { Size } from 'lib/styles';
import { Main } from 'styles/themeColors';

const Container = styled.div<any>`
  margin-right: ${Size.large};
  max-width: 20rem;
  outline: none;
  position: relative;
  user-select: none;

  ${props => !props.visible && css`
    visibility: hidden;
  `}
`;

const CountHeading = styled.div`
  align-items: center;
  color: ${Main.brandDark};
  display: flex;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;

const CountText = styled.div``;

const HeadingIcon = styled(Icon).attrs({ name: 'CaretDropdown', size: 10 })`
  margin-left: ${Size.medium};
  margin-top: ${Size.tiny};
`;

const StyledPopover = styled<any>(Popover)`
  min-width: 100%;
  width: auto;
`;

interface ErrorItem {
  type?: string;
  message?: string;
  [key: string]: any;
}

interface Props {
  className?: string;
  errors: ErrorItem[];
  visible: boolean;
  productRedesignFlag?: boolean;
}

export default function VariantErrorCount({
  className,
  errors,
  visible,
  productRedesignFlag = false
}: Props) {
  const [open, setOpen] = useState(false);

  if (!errors || errors.length === 0) {
    return null;
  }

  const countText = `${errors.length} error${errors.length > 1 ? 's' : ''}`;

  // Format errors for the popover
  const formattedErrors = errors.map((error) => ({
    name: error.code || 'Error',
    description: error.message || 'An error occurred',
    error
  }));

  let popover = null;

  if (open) {
    popover = (
      <StyledPopover
        maxHeight={500}
        options={formattedErrors}
        renderOption={(error: typeof formattedErrors[0]) => (
          <VariantIssueOption error={error} productRedesignFlag={productRedesignFlag} />
        )}
      />
    );
  }

  return (
    <Container
      className={className}
      onBlur={() => setOpen(false)}
      onClick={() => setOpen(!open)}
      tabIndex={0}
      visible={visible}
    >
      <CountHeading>
        <CountText>{countText}</CountText>
        <HeadingIcon className='heading-icon-black' />
      </CountHeading>
      {popover}
    </Container>
  );
}
